<template>
    <v-dialog
        v-model="display"
        width="100%"
        max-width="800px"
        :content-class="$vuetify.breakpoint.smAndUp ? 'guestEditDialogDesktop' : 'guestEditDialogMobile'"
        persistent
        scrollable>
        <v-card>
            <v-card-text class="pb-0">
                <v-container v-if="eventGuest" fluid class="px-0 pb-0">
                    <v-label>{{$t('guest.edit')}}</v-label>
                    <v-form ref="form" v-model="isFormValid">
                        <v-container fluid class="px-0 pb-0">
                            <v-row>
                                <v-file-input accept="image/*"
                                              :label="'Profile Picture'"
                                              v-model="eventGuest.ev_profile_pic"
                                              @change="handleProfilePictureChanged(eventGuest)">
                                    <template v-slot:selection="{file}">
                                        <v-img v-if="isImageSrcValid(eventGuest, 'ev_profile_pic')" :src="getImageSrc(eventGuest, 'ev_profile_pic')"
                                               max-width="250px"
                                               max-height="250px">
                                        </v-img>
                                    </template>
                                </v-file-input>
                            </v-row>

                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Username*"
                                        placeholder=" "
                                        v-model="eventGuest.guests.username"
                                        :rules="nameRules"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-checkbox class="my-0"
                                        v-model="showPassword"
                                        :label="$t('user.change_password')" >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        :label="$t('user.new_password')"
                                        :placeholder="$t('user.new_password')"
                                        v-model="password"
                                        :rules="passwordRules"
                                        :append-icon="revealPasswordText ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="revealPasswordText ? 'text' : 'password'"
                                        @click:append="revealPasswordText = !revealPasswordText"
                                        v-on:input="changePassword"
                                        v-if="showPassword"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        outlined
                                        ref="confirmPasswordEle"
                                        :label="$t('user.confirm_password')"
                                        :placeholder="$t('user.confirm_password')"
                                        v-model="confirmPassword"
                                        :rules="confirmPasswordRules"
                                        :append-icon="revealConfirmPasswordText ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="revealConfirmPasswordText ? 'text' : 'password'"
                                        @click:append="revealConfirmPasswordText = !revealConfirmPasswordText"
                                        v-if="showPassword"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        :label="$t('guest.name') + '*'"
                                        placeholder=" "
                                        v-model="eventGuest.ev_firstname"
                                        :rules="nameRules"></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Last Name"
                                        placeholder=" "
                                        v-model="eventGuest.ev_lastname"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Full Name"
                                        placeholder=" "
                                        v-model="eventGuest.ev_fullname"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        :label="$t('guest.name') + ' TC'"
                                        placeholder=" "
                                        v-model="eventGuest.ev_firstname_tc"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Last Name TC"
                                        placeholder=" "
                                        v-model="eventGuest.ev_lastname_tc"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Full Name TC"
                                        placeholder=" "
                                        v-model="eventGuest.ev_fullname_tc"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        :label="$t('guest.name') + ' SC'"
                                        placeholder=" "
                                        v-model="eventGuest.ev_firstname_sc"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Last Name SC"
                                        placeholder=" "
                                        v-model="eventGuest.ev_lastname_sc"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Full Name SC"
                                        placeholder=" "
                                        v-model="eventGuest.ev_fullname_sc"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Salutation"
                                        placeholder=" "
                                        v-model="eventGuest.ev_title"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Salutation TC"
                                        placeholder=" "
                                        v-model="eventGuest.ev_title_tc"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Salutation SC"
                                        placeholder=" "
                                        v-model="eventGuest.ev_title_sc"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Company"
                                        placeholder=" "
                                        v-model="eventGuest.ev_company"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Company TC"
                                        placeholder=" "
                                        v-model="eventGuest.ev_company_tc"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Company SC"
                                        placeholder=" "
                                        v-model="eventGuest.ev_company_sc"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Department"
                                        placeholder=" "
                                        v-model="eventGuest.ev_department"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Department TC"
                                        placeholder=" "
                                        v-model="eventGuest.ev_department_tc"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Department SC"
                                        placeholder=" "
                                        v-model="eventGuest.ev_department_sc"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Position"
                                        placeholder=" "
                                        v-model="eventGuest.ev_job_title"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Position TC"
                                        placeholder=" "
                                        v-model="eventGuest.ev_job_title_tc"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Position SC"
                                        placeholder=" "
                                        v-model="eventGuest.ev_job_title_sc"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Country Code"
                                        placeholder=" "
                                        v-model="eventGuest.ev_country_code"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="vip(1/0)"
                                        placeholder=" "
                                        v-model="eventGuest.ev_vip_flag"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Office #"
                                        placeholder=" "
                                        v-model="eventGuest.ev_office_phone"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Mobile #"
                                        placeholder=" "
                                        v-model="eventGuest.ev_mobile"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Email *"
                                        placeholder=" "
                                        v-model="eventGuest.ev_email"
                                        :rules="emailRules"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Qrcode *"
                                        placeholder=" "
                                        v-model="eventGuest.ev_token"
                                        :rules="tokenRules"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Employee ID"
                                        placeholder=" "
                                        v-model="eventGuest.ev_employeeid"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                            label="Agency ID"
                                            placeholder=" "
                                            v-model="eventGuest.ev_agencyid"
                                            ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-select outlined
                                        label="Local/Oversea"
                                        :items="['local', 'oversea']"
                                        v-model="eventGuest.ev_local_oversea"
                                        ></v-select>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Passcode"
                                        placeholder=" "
                                        v-model="eventGuest.ev_passcode"
                                    ></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Wechat OpenID"
                                        placeholder=" "
                                        v-model="eventGuest.ev_wechat_openid"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-checkbox
                                        label="Private account"
                                        v-model="eventGuest.ev_private_account"
                                        false-value="no"
                                        true-value="yes"
                                        ></v-checkbox>
                                </v-col>
                                <v-col>
                                    <v-checkbox
                                        label="Notification"
                                        v-model="eventGuest.ev_notification"
                                        false-value="no"
                                        true-value="yes"
                                        ></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Remarks"
                                        placeholder=" "
                                        v-model="eventGuest.ev_remarks"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Metadata"
                                        placeholder=" "
                                        v-model="eventGuest.metadata"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Sms"
                                        placeholder=" "
                                        v-model="eventGuest.ev_sms"
                                        ></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="No reminder(1/0)"
                                        placeholder=" "
                                        v-model="eventGuest.ev_exclude_email_reminder"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="secondary" @click="closeDialog">
                    {{$t('cancel')}}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveEventGuest">
                    {{$t('save')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {computed, ref} from "@vue/composition-api";
    import {useFind, useGet} from "feathers-vuex";

    export default {
        name: 'EventGuestEdit',
        props: {
            displayGuestEditDialog: Boolean
        },
        setup(props, {root}) {
            const {EventGuest, Guest} = root.$FeathersVuex.api;
            
            const display = ref(true);
            
            const form = ref(null);
            const isFormValid = ref(false);
            const showPassword = ref(false);
            const password = ref("");
            const confirmPassword = ref("");
            const revealPasswordText = ref(false);
            const revealConfirmPasswordText = ref(false);
            const confirmPasswordEle = ref(null);

            const eventId = computed(() => root.$route.params.eventId);
            const guestId = computed(() => root.$route.params.guestId);
            const eventGuestId = computed(() => eventGuests.value && eventGuests.value[0] ? eventGuests.value[0].id : null);

            const eventGuestParams = computed(() => {
                let params = {
                    query: {
                        eventId: eventId.value,
                        guestId: guestId.value
                    },
                    paginate: false
                };
                return params;
            });
            const {items: eventGuests} = useFind({model: EventGuest, params: eventGuestParams});
            const {item: guest} = useGet({model: Guest, id: guestId});
            const {item: eventGuest} = useGet({model: EventGuest, id: eventGuestId});

            const nameRules = ref([
                value => !!value || 'Required',
            ]);

            const emailRules = ref([
                value => /^[^@]+@[^@]+\.[^@]+$/.test(value) || 'Invalid Email formant ',
            ]);

            const tokenRules = ref([
                value => !!value || 'Required',
            ]);

            const passwordRules = ref([
                value => ((value || '').length == 0 || (value || '').length >= 4) || 'Min 4 characters',
            ]);
            
            const confirmPasswordRules = ref([
                value => !!value || 'Password Not Match',
                value => (value == password.value) || 'Password Not Match',
            ]);
            
            const getImageSrc = (obj, field)=>{
                if (obj && obj[field]) {
                    return obj[field].src
                        ? obj[field].src
                        : (obj.src ? obj.src : obj[field]);
                }
            }
            const isImageSrcValid = (obj, field) => {
                const objSrc = getImageSrc(obj, field);
                return (objSrc && objSrc.includes('http'));
            }
            const handleProfilePictureChanged = (e) => {
                if (e.ev_profile_pic instanceof File) {
                    e.src = URL.createObjectURL(e.ev_profile_pic);
                } else {
                    e.src = '';
                    e.ev_profile_pic = '';
                }
            }
            
            const closeDialog = () => {
                root.$router.replace({name: 'event-guests'});
            }

            const saveEventGuest = async () => {
                if (isFormValid.value) {
                    try {
                        if (eventGuest.value.ev_profile_pic instanceof File) {
                            eventGuest.value.ev_profile_pic = {src: await root.$uploadFile(eventGuest.value.ev_profile_pic)};
                        }
                        if (!eventGuest.value.ev_profile_pic) {
                            eventGuest.value.ev_profile_pic = null;
                        }

                        guest.value.username = eventGuest.value.guests.username;
                        if (!showPassword.value) {
                            delete guest.value.password;
                        } else {
                            guest.value.password = password.value;
                        }

                        await guest.value.save().then(async () => {
                            await eventGuest.value.save()
                        }, (e) => {
                            e.errors[0].message = "Username must be unique";
                            throw e;
                        })
                        
                        root.$store.dispatch('showSnackBar', 'Guest Saved.');
                        closeDialog();
                    } catch (e) {
                        root.$handleFeatherError(e);
                    }
                } else {
                    form.value.validate();
                }
            };

            const changePassword = () => {
                confirmPasswordEle.value.validate();
            };
            
            return {
                form,
                isFormValid,
                nameRules,
                emailRules,
                tokenRules,
                saveEventGuest,
                
                guestId,
                guest,
                eventGuestId,
                eventGuest,

                showPassword,
                password,
                confirmPassword,
                passwordRules,
                confirmPasswordRules,
                revealPasswordText,
                revealConfirmPasswordText,
                confirmPasswordEle,
                changePassword,

                getImageSrc,
                isImageSrcValid,
                handleProfilePictureChanged,

                closeDialog,
                display
            }
        },
    }
</script>